/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  ProfileCardService,
  IProfileCardMethods,
  IUpdateProfileMethods,
  UpdateProfileService,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
} from './components';

export type ProfilePageAgent = IHeaderMethods &
  IUpdateProfileMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IProfileCardMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new ProfileCardService(),
    new UpdateProfileService(),
    new StaticPageContentService(),
    new LoadingService(),
  ];
};

export const getAgent = () => {
  return createAgent<ProfilePageAgent>({
    plugins: getPlugins(),
  });
};
